const getJwt = () => localStorage.getItem('jwt-token')
export default getJwt
